<template>
  <el-dialog title="" 
    :visible.sync="dialogVisible" custom-class="ai-dialog-form tkd" :before-close="beforeCloseHandler" append-to-body @closed="closeDialog" :close-on-click-modal="false" width="762px" >
      <div slot="title" class="header_part">
        <span class="title">{{$t('components_ai_command_tkd_1956')}}</span>
      </div>
        <el-form @submit.native.prevent ref="dialogForm" :model="dialogForm" :label-position="labelPosition" :label-width="$store.state.app.web_language_wm == 'en' ? 'auto' : '95px'" :rules="dialogFormRules">       
          <el-form-item :label="$t('components_ai_command_tkd_1957')+ seo_type_title +$t('components_ai_command_tkd_1958')" prop="keywords">           
            <el-input
              :maxlength="100"
              show-word-limit              
              v-model="dialogForm.keywords"
              :placeholder="$t('components_ai_command_tkd_1959')"
              autocomplete="off">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('components_ai_command_tkd_1960')" prop="company">
            <el-input
              :maxlength="100"
              show-word-limit
              type="textarea"
              rows="3"
              :placeholder="$t('components_ai_command_tkd_1961')"
              v-model="dialogForm.company"
              >
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('components_ai_command_tkd_1962')" prop="desc">
              <el-input
                :maxlength="500"
                show-word-limit
                type="textarea"
                rows="4"
                :placeholder="$t('components_ai_command_tkd_1963')+'\n'+ $t('components_ai_command_tkd_1964')"
                v-model="dialogForm.desc"
                >
            </el-input>
          </el-form-item>
         
          <el-button @click="generateAiContent" :loading="loading" style="width:100%" type="primary" >{{ btnTitle }} </el-button>
          <div v-if="statementShow" class="statement">{{$t('components_ai_command_tkd_1965')}}</div>
        </el-form>

        <div v-show="resultContShow" class="intelligence-content">
          <div class="intelligence-content-top flex_center_center">
                <div v-if="!loading" @click="importCont" :class="loading ? 'loading' : ''" class="btn import">{{$t('components_ai_command_tkd_1966')}}</div>
                <div v-if="!loading" @click="copyCont" :class="loading ? 'loading' : ''" class="btn copy">{{$t('components_ai_command_tkd_1967')}}</div>
            </div>
          <div v-html="content" class="intelligence-content-box"></div>
        </div>
      </el-dialog>
</template>

<script>
import i18n from '../../language/index'

import {
  gptUsageCount,
  splitAiContent,
  getAiCommand
} from "@/api/app.js"
import { fetchEventSource } from '@microsoft/fetch-event-source'
import { getStr } from '@/utils/utils.js'
import Cookies from 'js-cookie'

export default {
  name: "tkd",
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    command_type: {
      type: String,
      required: true,
      default: "",
    },
    seoTitleType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      labelPosition: 'top',
      role: false,
      error: false,
      resultContShow: false,
      statementShow: true,
      content: '',
      btnTitle:i18n.t('components_ai_command_tkd_1968'),
      dialogForm: {
        type: '',
        subject: '',
        keywords: '',
        desc: '',
        length: '',
      },
      dialogFormRules: {
        keywords: [
          { required: true, message: i18n.t('components_ai_command_tkd_1969'), trigger: 'blur' }
        ],
      },

    };
  },
  components: {

  },
  watch: {
    isShow(val) {
      this.dialogVisible = val
      console.log('this.dialogVisible', this.dialogVisible);
    }
  },
  computed: {
    seo_type_title() {
      let ret = ''
      if (this.seoTitleType) {
        const key = this.seoTitleType;
        switch (key) {
          case 'article':
            ret = i18n.t('widgets_basic_article_classification_edit_333')
            break;
          case 'case':
            ret = i18n.t('widgets_basic_article_classification_edit_334')
            break;
          case 'help':
            ret = i18n.t('widgets_basic_article_classification_edit_335')
            break;
          case 'video':
            ret = i18n.t('view_download_index_181')
            break;
          case 'download':
            ret = i18n.t('router_index_69')
            break;
          case 'product':
            ret = i18n.t('widgets_basic_classification_edit_482')
            break;
          case 'article_type':
            ret = i18n.t('base_options_config_1726')
            break;
          case 'case_type':
            ret = i18n.t('base_options_config_1727')
            break;
          case 'help_type':
            ret = i18n.t('base_options_config_1728')
            break;
          case 'video_type':
            ret = i18n.t('components_ai_command_tkd_1970')
            break;
          case 'download_type':
            ret = i18n.t('components_ai_command_tkd_1971')
            break;
          case 'product_type':
            ret = i18n.t('base_options_config_1725')
            break;
          default:
            break;
        }
      }
      return ret;
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:isShow', false);
      this.btnTitle = i18n.t('components_ai_command_tkd_1968');
      this.content = ''
      this.resultContShow = false
      this.statementShow = true
      this.$refs.dialogForm.resetFields()
    },
    beforeCloseHandler() {
      if(this.loading){
        this.$message.error(i18n.t('components_ai_command_tkd_1972'))
        return false;
      }
      if (this.content) {
        this.$confirm(i18n.t('components_ai_command_tkd_1973'), i18n.t('view_public_topbar_23'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(() => {
          this.dialogVisible = false
        }).catch(() => { })
      } else {
        this.dialogVisible = false
      }
    },
    async getGptUsageCount() {
      let res = await gptUsageCount()
      if (res.code == 200) {
        if (res.data && res.data.count > 0) {
          this.role = true
        }
      }
    },
    async generateAiContent() {
      let tag = true;
      this.$refs['dialogForm'].validate(valid => {
        tag = valid;
      })
      if(!tag){
        return;
      }
      this.content = ''
      this.loading = true;
      this.btnTitle = i18n.t('components_ai_command_tkd_1974');
      if (!this.role) {
        this.$message.error(i18n.t('components_ai_command_tkd_1975'))
        this.loading = false;
        this.btnTitle = i18n.t('components_ai_command_tkd_1968');
        return false;
      }
      // 获取指令
      const params = Object.assign(this.dialogForm, { 'type': this.command_type })
      let res = await getAiCommand(params)
      if (res.data) {
        this.doSearch(res.data)      
      } else {
        this.loading = false;
        this.btnTitle = i18n.t('components_ai_command_tkd_1968');
        this.$message.error(i18n.t('components_ai_command_tkd_1976'))
      }

    },
    doSearch(cont) {
      const _that = this;
      const serverURL = process.env.BASE_Console_Login_Domain + "/ai-article/gpt/history/make"
      const params = {
        "prompt": cont,
        "mode": 1,
        "platform": 6,
      }
      fetchEventSource(serverURL, {
        method: 'POST',
        headers: {
          "Content-Type": 'application/json',
          "x-token": Cookies.get('X-Token')
        },
        openWhenHidden: true,
        body: JSON.stringify(params),
        onopen(e) {
          _that.resultContShow = true;
          _that.btnTitle = i18n.t('components_ai_command_tkd_1974');
          _that.statementShow = false;
          _that.loading = true
          console.log('连接成功', e)
        },
        onmessage(source) {
          if (getStr(source.data).id) {
            // 获取会话上下文id 如果需要保持会话 则需要在下次会话时在params中带上该id参数
            _that.chatId = getStr(source.data).id
          }
          if (getStr(source.data).msg) {
            _that.content += getStr(source.data).msg.replace(/\n/ig, '<br/>')
          }
          if (getStr(source.data).errMsg) {
            _that.loading = false
            _that.error = true
            _that.errMsg = getStr(source.data).errMsg
          }
        },
        onclose(e) {
          _that.loading = false
          _that.btnTitle = i18n.t('components_ai_command_tkd_1977');                  
          console.log('关闭')
        },
        onerror(err) {
          _that.loading = false
          _that.error = true
          console.log('异常', err)
          throw new Error(i18n.t('components_ai_command_tkd_1978'))
        }
      })

    },
    copyCont() {
      var input = document.createElement('textarea');
      input.value = this.content.replace(/<br\/>/g, '\n');
      document.body.appendChild(input);
      input.select();
      if (input.value) {
        document.execCommand('copy');
        this.$message({
          message: i18n.t('components_ai_command_tkd_1979'),
          type: 'success'
        });
      } else {
        this.$message({
          message: i18n.t('components_ai_command_tkd_1980'),
          type: 'warning'
        });
      }
      document.body.removeChild(input);
    },
     importCont() {
      if (this.loading) {
        return false
      }
      const _that = this;
      splitAiContent({
        type: this.command_type,
        content: this.content
      }).then(res => {
        if (res.code == 200) {
          if (res.data.seo_title && res.data.seo_description) {
            _that.$emit('pushTkd', res.data)
            _that.$emit('closeDialogForm');
            this.$message.success(i18n.t('components_ai_command_tkd_1981'));
            _that.$refs.dialogForm.resetFields()
            _that.btnTitle = i18n.t('components_ai_command_tkd_1968');
            _that.content = '';
            _that.resultContShow = false;
            _that.statementShow = true;
          }else{
            this.$message.error(i18n.t('components_ai_command_tkd_1982'))
          }
        }else{
          this.$message.error(i18n.t('components_ai_command_tkd_1983'))
        }
      })
        .catch(err => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    
    this.getGptUsageCount()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ai_command/tkd.vue